import React from 'react';
import '../styles/components.css';
export const SolidImage = ({ imgPath }) => {
    return (
        <div className='solid-image'>
            <div></div>
            <img src={imgPath} alt="solid-component" />
        </div>
    );
};

export const SolidImageCarMob = ({ imgPath }) => {
    return (
        <div className='solid-image'>
            <img src={imgPath} alt="solid-component" />
        </div>
    );
};

export const SolidImageCar = ({ imgPath }) => {
    return (
        <div className='solid-image-right'>
            <img src={imgPath} alt="solid-component-right" />
        </div>
    );
};

export const SolidImageRight = ({ imgPath }) => {
    return (
        <div className='solid-image-right'>
            <div></div>
            <img src={imgPath} alt="solid-component-right" />
        </div>
    );
};

export const SolidImageLeft = ({ imgPath }) => {
    return (
        <div className='solid-image-left'>
            <div></div>
            <img src={imgPath} alt="solid-component-left" />
        </div>
    );
};